module.exports = __webpack_public_path__ + "assets/2fe2904fc024afaf81732563cb83e547.js";